import { render, staticRenderFns } from "./GStudentAllCompetencyChart.vue?vue&type=template&id=c84e9f36&scoped=true&"
import script from "./GStudentAllCompetencyChart.vue?vue&type=script&lang=ts&"
export * from "./GStudentAllCompetencyChart.vue?vue&type=script&lang=ts&"
import style1 from "./GStudentAllCompetencyChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e9f36",
  null
  
)

export default component.exports